import { BATTING_ORDER_SLOT_IDS } from "../constants/fanPage";

export const getFanPagePath = (handle) => `/u/${handle}`;

export const getPlayerPath = (playerId, sport = "mlb") => {
  const id = String(playerId || "").trim();
  if (!id) return null;
  if (sport === "nba") return `/app/nba/player/${id}`;
  if (sport === "nfl") return `/app/nfl/player/${id}`;
  return `/app/player/${id}`;
};

export const getFanPageUrl = (handle) => {
  if (typeof window === "undefined") return getFanPagePath(handle);
  return `${window.location.origin}${getFanPagePath(handle)}`;
};

export const getLineupPlayerIds = (lineup = {}) =>
  Object.values(lineup)
    .map((slot) => slot?.playerId)
    .filter(Boolean);

export const formatPositionLeaderValue = (metric, value) => {
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "";
  if (metric === "ops" || metric === "battingAverage") {
    return amount.toFixed(3).replace(/^0/, "");
  }
  if (metric === "era") return amount.toFixed(2);
  const display = amount.toLocaleString();
  if (metric === "wins") return `${display} W`;
  if (metric === "homeruns") return `${display} HR`;
  if (metric === "hits") return `${display} H`;
  if (metric === "rbi") return `${display} RBI`;
  if (metric === "strikeOuts") return `${display} K`;
  return display;
};

export const battingOrderPlayerIds = (battingOrder = {}) =>
  BATTING_ORDER_SLOT_IDS.map((hole) => battingOrder?.[hole]?.playerId).filter(
    Boolean
  );

export const battingOrderMovePatch = (order, holeId, delta) => {
  const index = BATTING_ORDER_SLOT_IDS.indexOf(String(holeId));
  const nextIndex = index + delta;
  if (index < 0 || nextIndex < 0 || nextIndex >= BATTING_ORDER_SLOT_IDS.length) {
    return null;
  }
  const from = BATTING_ORDER_SLOT_IDS[index];
  const to = BATTING_ORDER_SLOT_IDS[nextIndex];
  const fromId = order?.[from]?.playerId ?? null;
  const toId = order?.[to]?.playerId ?? null;
  if (fromId === toId) return null;
  return { [from]: toId, [to]: fromId };
};

export const formatBattingSlash = ({ battingAverage, homeruns, ops } = {}) => {
  const avg = formatPositionLeaderValue("battingAverage", battingAverage);
  const opsText = formatPositionLeaderValue("ops", ops);
  const hr = Number(homeruns);
  const hasHr = Number.isFinite(hr) && hr > 0;
  if (!avg && !opsText && !hasHr) return "";
  const hrLabel = Number.isFinite(hr) ? `${hr.toLocaleString()} HR` : "— HR";
  return `${avg || "—"} / ${hrLabel} / ${opsText || "—"} OPS`;
};
